import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output, ViewChild
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import * as _ from "lodash";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {Subscription} from "rxjs";
import {VisitPlanFacadeService} from "../../services/visit-plan-facade.service";
import {VisitScheduleResourceHolderExt} from "../../../models/visit-schedule-resource-holder-ext.model";

interface VisitPlanResourceHoldersMultiSelectListModel {
  selectedIds: string[];
  branchIds: string[];
  visitPlanId: string;
  visitScheduleId: string;
  ngPlaceholder?: string;
}

require('./visit-plan-resource-holders-multi-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-resource-holders-multi-select-list',
  templateUrl: './visit-plan-resource-holders-multi-select-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanResourceHoldersMultiSelectListComponent implements OnInit, OnDestroy {

  @Output() onClose = new EventEmitter<{ agentIds: string[] }>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public selectedIds: string[];
  public queryString: string = '';
  public selectedKeys: { [key: string]: boolean };
  public loadLimit: number = 20;
  public resourceHolders: VisitScheduleResourceHolderExt[] = [];
  public ngPlaceholder: string;
  public cursor: string;
  public isLoading: boolean;

  private sub: Subscription;

  constructor(@Inject(PANEL_DATA) public data: VisitPlanResourceHoldersMultiSelectListModel,
              @Inject(VisitPlanFacadeService) private visitPlanFacadeService: VisitPlanFacadeService,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.selectedIds = this.data.selectedIds || [];
    this.ngPlaceholder = this.data.ngPlaceholder;

    this.setSelectedIdsMap();
    this._getResourceHolders(true);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport?.measureScrollOffset('bottom') < 150 && this.cursor && !this.isLoading) {
      this._getResourceHolders();
    }
  }

  onToggle(holderId, isSelected) {
    this.selectedIds = !isSelected ? _.concat(this.selectedIds || [], [holderId]) :
      _.filter(this.selectedIds, (id) => {
        return id !== holderId;
      });

    this.setSelectedIdsMap();
    this.cdr.detectChanges();
  }

  onSubmit() {
    this.onClose.emit({agentIds: this.selectedIds});
  }

  onReset() {
    this.onClose.emit({agentIds: []});
  }

  onCancel() {
    this.onClose.emit({agentIds: this.data.selectedIds || []});
  }

  onQueryChange(query) {
    this.queryString = query;
    this._getResourceHolders(true);
  }

  onToggleSelectAll() {
    if (this.resourceHolders?.length === this.selectedIds?.length) {
      this.selectedIds = [];
      this.setSelectedIdsMap();
    } else {
      this.selectedIds = this.resourceHolders.map((h) => h.holderId);
      this.setSelectedIdsMap();
    }
    this.cdr.detectChanges();
  }

  private setSelectedIdsMap() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (id) => {
      this.selectedKeys[id] = true;
    });
  }

  private _getResourceHolders(reset: boolean = false) {
    if (reset) {
      this.cursor = undefined;
      this.resourceHolders = [];
    }

    this.isLoading = true;
    this.cdr.detectChanges();

    const params: any = {
      limit: this.loadLimit,
      sort: 'holderName,asc'
    };

    if (this.cursor) {
      params.cursor = this.cursor;
    }

    if (this.queryString) {
      params.query = this.queryString;
    }

    if (this.data.branchIds?.length) {
      params.projectBranchIds = this.data.branchIds;
    }

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

    this.sub?.unsubscribe();
    this.sub = this.visitPlanFacadeService.getResourceHoldersWithCursor(this.data.visitPlanId, this.data.visitScheduleId, params)
      .subscribe({
        next: (res) => {
          this.resourceHolders = reset ? res.list : [...this.resourceHolders, ...res.list];
          this.cursor = res.cursor;
          this.isLoading = false;
          this.cdkVirtualScrollViewport?.checkViewportSize();
          this.cdr.detectChanges();
        },
        error: () => {
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

}
